import React from 'react';
import ReactDOMClient, { createRoot } from 'react-dom/client';
import { unstable_HistoryRouter as HistoryRouter, Routes } from 'react-router-dom';
import history from 'history/browser';
import { Provider } from 'react-redux';

import { store } from 'src/store';
import { Routes as AppRoutes } from 'src/routes';

const container = document.getElementById('root');

const Wrap = (
  <Provider store={store}>
    <HistoryRouter history={history as any}>
      <Routes>{AppRoutes}</Routes>
    </HistoryRouter>
  </Provider>
);

if (container) {
  if (process.env.WEBSITE_SSR) {
    ReactDOMClient.hydrateRoot(container, Wrap);
  } else {
    createRoot(container).render(Wrap);
  }
} else {
  throw new Error('No #root element in DOM');
}
